import styles from './Topbar.module.css';

const TopbarLogin = () => {
  return (
    <div className={styles.topbar}>
      <span className={styles.logo}>The Gottman Initiative</span>
    </div>
  );
};

export default TopbarLogin;
